import React, { forwardRef } from 'react';
import CustomLink from "./customLink";

const MointerStudent = forwardRef(({data}, ref) => {

  return (
    <section ref={ref} className="moniter-time">
      <div className="container">
        <h2>{data.title}
        </h2>
        <p className='para-text text-center'>{data.subtitle}</p>
        <p className='para-text text-center mt-3'>{data.para}</p>
        <div className="col-md-12 btn-wrapper">
          <a type='btn' className='btn primary-btn' href={data.button.link} target="_blank">{data.button.text}</a>
        </div>
        <div className="inner-container">

          <div className="text-center img-box">
            <img src={data.image} alt="monitoring" />
          </div>

          <div className="col-md-12 card-row">
            {data.cardsRow1.map((item, index) => (
              <div 
                key={index}
                className="card-animation"
                data-aos={item.aos}
                data-aos-delay={item.delay}
              >
                <div className={`innter-card ${item.cardClass}`}>
                  <div className="innter-box">
                    <p>
                      <span>{item.heading}</span> {item.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="col-md-12 card-row row-margin">
            {data.cardsRow2.map((item, index) => (
              <div 
                key={index}
                className="card-animation"
                data-aos={item.aos}
                data-aos-delay={item.delay}
              >
                <div className={`innter-card ${item.cardClass}`}>
                  <div className="innter-box">
                    <p>
                      <span>{item.heading}</span> {item.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
        {/* <div className="inner-container">
          <div className="text-center img-box">
            <img src="/img/school-home/innter-center.png" alt="monitiring" />
          </div>
          <div className='col-md-12 card-row'>
            <div className="card-animation" data-aos="fade-right" data-aos-delay="100">
              <div className="innter-card card-1">
                <div className="innter-box">
                  <p><span>International Standings</span>: Compare performance globally: fantastic for schools emphasizing STEM learning and competitive prep.</p>
                </div>
              </div>
            </div>

            <div className="card-animation" data-aos="fade-left" data-aos-delay="150">
              <div className="innter-card right-side-card">
                <div className="innter-box">
                  <p><span>Intuitive Dashboard</span>: Track enrollments, results, insights, and performance trends with ease.</p>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-12 card-row row-margin'>
            <div className="card-animation" data-aos="fade-right" data-aos-delay="200">
              <div className="innter-card bottom-left-card">
                <div className="innter-box">
                  <p><span>Individual Feedback</span>: Understand how your students perform on international level with competitive ranking features.</p>
                </div>
              </div>
            </div>
            <div className="card-animation" data-aos="fade-left" data-aos-delay="250">
              <div className="innter-card bottom-right-card">
                <div className="innter-box">
                  <p><span>Detailed Reports</span>: Monitor student enrollments and track their progress effortlessly with a user-friendly interface.</p>
                </div>
              </div>
            </div>

          </div>
        </div> */}

      </div>
    </section>
  )
});

export default MointerStudent